import { SAVE_VALUE } from 'actions/savedSearches';

/**
 * Store saved URL search segments by key (root page)
 */
const INITIAL_STATE = {};

export default function savedSearchParamsReducer(
  state = INITIAL_STATE,
  action,
) {
  const { type, payload } = action;

  switch (type) {
    case SAVE_VALUE: {
      const { key, value, scope = 'global' } = payload;
      const currentScope = state[scope] ?? {};
      const updatingScope = { ...currentScope };

      if (!value) {
        delete updatingScope[key];
      } else {
        updatingScope[key] = value;
      }
      const updatingState = { ...state, [scope]: updatingScope };
      return updatingState;
    }
    default: {
      return state;
    }
  }
}
